jQuery.feature_import("js-orderListExceptionDays",
  () => require("./OrderListHoliday.js"),
  mod => mod.feature_js_orderListExceptionDays
);